export default {
    overpass: 'https://fonts.googleapis.com/css?family=Overpass',
    sourceCodePro: 'https://fonts.googleapis.com/css?family=Source+Code+Pro',
    fonts: {
      body: '"Overpass"',
      monospace: '"Source+Code+Pro"',
    },
    colors: {
      text: '#1c0a14',
      background: '#fffff2',
      primary: '#f1935c',
    },
    styles: {
      CodeSurfer: {
        pre: {
          color: "text",
          backgroundColor: "background"
        },
        code: {
          color: "text",
          backgroundColor: "background"
        },
        tokens: {
          "comment cdata doctype": {
            fontStyle: "italic"
          },
          "builtin changed keyword punctuation operator tag deleted string attr-value char number inserted": {
            color: "primary"
          },
          "line-number": {
            opacity: 0.8
          }
        },
        title: {
          backgroundColor: "background",
          color: "text"
        },
        subtitle: {
          color: "#d6deeb",
          backgroundColor: "rgba(10,10,10,0.9)"
        },
        unfocused: {
          // only the opacity of unfocused code can be changed
          opacity: 0.1
        }
      }
    }
  };